import axios from "axios";
import qs from "qs";
import store from "../store";
import router from '@/router'; 
import { setToken , getToken } from '../../static/js/util.js';

// axios.defaults.withCredentials=true;
export const Request = {};
//请求超时时长
const TIMEOUT = 20000;
var request = options => {
    options.headers = {
        "Content-Type": "application/x-www-form-urlencoded"
    };
    options.headers = { ...(options.headers || {}) };
    options.body = { ...(options.body || {}) };
    //参数格式化
    if (Object.prototype.toString.call(options.body) === "[object Object]") {
        options.body = qs.stringify(options.body);
    }
    return  new Promise((resolve, reject) => {
        axios.request({
            headers: options.headers,
            url: options.action,
            method: options.method,
            data: options.body,
            params: options.params,
            timeout: TIMEOUT,
            emulateJSON: true,
            withCredentials : true
        })
        .then(response => {
            if(getToken("unique_code")){
                setToken("unique_code",getToken("unique_code"),0.3333333)
            }
            const { data } = response
            const { code } = data
            if (parseInt(code) === 1) {
                resolve(data.data)  
            }else if(parseInt(code) === 2){ 
                store.commit('setUserInfo', '')//登录超时后清空vuex里的用户数据
                setToken("unique_code","",0)//登录超时后清空cookie里的用户唯一标示
                // Message.warning("登录超时，请重新登录");
                //let urlAction=options.action;//预留变量（当前请求的接口）；加入授权/加入收藏 可一块根据请求接口做判断
                if(location.pathname.split("/")[1]==="personalCenter"){
                    router.push({path:"/login",name:"login",params:{loginState:"false"}})
                }
                resolve(data.data)
            }else{
                reject(data)
            }
        })
        .catch(e => {
            throw e;
        });
    })
};
//http请求方式
const http = {};
["get", "post", "put", "delete"].forEach(method => {
    http[method] = (
        action,
        params,
        typs = 1,
        extra = { headers: {}, loadig: false, includeToken: false }
    ) => {
        method = method.toUpperCase();
        // if (process.env.NODE_ENV == "development") {
        //     // 测试接口
        //     alert(1)
        //     if (typs == 1) action = "http://127.0.0.1:8086/dance" + action;
        // } else {
        //     // 正式接口
        //     alert(2)
        //     if (typs == 1) action = "http://127.0.0.1:8086/dance" + action;
        // }
        //http://39.98.217.184:8025
        // if (typs == 1) action ="https://guoshi.qikan.com" + action;  //正式
        // if (typs == 1) action ="http://39.98.217.184:8025" + action;  //测试
        // if (typs == 1) action ="http://guoshi.k-blockchain.cn" + action;  //临时
        if (typs == 1) action =action;    //本地

        if (method === "GET") {
            return request({
                action,
                params,
                method,
                headers: extra.headers,
                loading: extra.loading,
                includeToken: extra.includeToken
            });
        }
        return request({
            action,
            body: params,
            method,
            headers: extra.headers,
            loading: extra.loading,
            includeToken: extra.includeToken
        });
    };
});
Request.http = http;



// WEBPACK FOOTER //
// ./src/api/request.js